import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RecentActorsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"recent_actors"}/>
}
